import * as types from "./actionTypes";

export const setCumulativeInstallByYear = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CUMULATIVE_INSTALL_BY_YEAR,
      key,
      yearKey,
      amount,
    });
  };
};

export const setCumulativeInstallByMonth = (key, yearKey, amount) => {
  return (dispatch) => {
    return dispatch({
      type: types.SET_CUMULATIVE_INSTALL_BY_MONTH,
      key,
      yearKey,
      amount,
    });
  };
};

export const replaceCumulativeInstallYears = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.REPLACE_CUMULATIVE_INSTALL_YEARS,
      key,
      payload,
    });
  };
};

export const resetCumulativeInstallReducer = (key, payload) => {
  return (dispatch) => {
    return dispatch({
      type: types.RESET_CUMULATIVE_INSTAL_REDUCER,
      key,
      payload,
    });
  };
};
